










































































































































































import {
  CalendarHolidayFieldError,
  ICalendarHoliday,
  ICalendarHolidayData,
  EmployeeType,
  TimeOffStateEnum
} from '@/models';
import { AxiosError } from 'axios';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep } from '@/utils/helpers';
import { cloneDeep } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import moment from 'moment';
import TimeOffHolidayCalendarPicker from '../time-off-calendar/TimeOffHolidayCalendarPicker.vue';
import UploadHolidayFormCard from '../time-off-calendar/UploadHolidayFormCard.vue';
import { IFetchCalendarHolidaysParams } from '@/services/timeoff-calendar';
import ALDialog from '../core/Dialog/ALDialog.vue';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    calendarHolidayUploadFormCard: InstanceType<typeof UploadHolidayFormCard>;
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'HolidayDetailFormDialog',

    components: {
      ErrorAlert,
      TimeOffHolidayCalendarPicker,
      UploadHolidayFormCard,
      ALDialog
    },

    data() {
      return {
        EmployeeType,
        dialog: false,
        calendarHolidayFormValid: false,
        calendarUploadHolidayFormValid: false,
        dateValue: moment().format('YYYY-MM-DD'),
        isEdit: false,
        loading: false,
        dateMenu: false,

        calendarHoliday: { is_paid: true, name: '' } as ICalendarHolidayData,
        fieldError: new CalendarHolidayFieldError(),
        errorMessage: '',
        errorMessageDetail: '',

        requiredRules: [(v: string) => !!v || 'This field is required'],

        legendList: [
          {
            state: TimeOffStateEnum.PaidHoliday,
            display_name: 'Paid Holiday',
            color: 'blue'
          },

          {
            state: TimeOffStateEnum.UnpaidHoliday,
            display_name: 'Unpaid Holiday',
            color: 'orange'
          }
        ],

        tab: 0,
        formTab: 0,
        dataImportTab: 1
      };
    },

    computed: {
      ...mapGetters({
        getCalendarHolidayById: 'timeOffCalendar/getCalendarHolidayById',
        getCalendarHolidays: 'timeOffCalendar/getCalendarHolidays'
      }),

      calendarHolidayDateList(): string[] {
        const holidays = this.getCalendarHolidays(
          this.calendarHoliday.calendar
        ).map((data: ICalendarHoliday) => data.date);

        return holidays;
      },

      formTitle(): string {
        if (this.tab == this.formTab) {
          return `${this.isEdit ? 'Edit' : 'Create'} a Company Holiday`;
        } else {
          return 'Upload Company Holiday File';
        }
      }
    },

    methods: {
      ...mapActions({
        createCalendarHoliday: 'timeOffCalendar/createCalendarHoliday',
        updateCalendarHoliday: 'timeOffCalendar/updateCalendarHoliday'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(calendarId: number, calendarHoliday?: ICalendarHoliday) {
        if (calendarHoliday) {
          this.calendarHoliday = cloneDeep(calendarHoliday)!;
          this.dateValue = this.calendarHoliday.date!;
        }

        this.isEdit = !!calendarHoliday;
        this.clearAllErrors();
        this.calendarHoliday.calendar = calendarId;
        this.tab = this.formTab;
        this.dialog = true;

        this.resetFormValidation();
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.clearAllErrors();
        this.calendarHoliday = { is_paid: true };
        this.dateValue = moment().format('YYYY-MM-DD');
        this.dialog = false;
      },

      refresh(uploadParams: IFetchCalendarHolidaysParams) {
        this.$emit('refresh', uploadParams);
      },

      holidayIndicatorColor(date: string): string {
        const holiday: ICalendarHoliday = this.getCalendarHolidays(
          this.calendarHoliday.calendar
        ).find((holiday: ICalendarHoliday) => holiday.date == date);
        return holiday.is_paid ? 'blue' : 'orange';
      },

      async uploadCalendarHoliday() {
        this.loading = true;

        try {
          const calendarHolidayUploadFormCard = this.$refs
            .calendarHolidayUploadFormCard;
          // No need for a catch as error is already caught in the function
          if (calendarHolidayUploadFormCard) {
            // need to wait for api call to resolve
            await calendarHolidayUploadFormCard.uploadHoliday();
          }
        } finally {
          this.loading = false;
        }
      },

      async saveCalendarHoliday(): Promise<void> {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;

          this.calendarHoliday.date = this.dateValue;

          try {
            if (this.isEdit) {
              const calendarHolidayDelta = diffDeep(
                this.calendarHoliday,
                this.getCalendarHolidayById(
                  this.calendarHoliday.id,
                  this.calendarHoliday.calendar as number
                ),
                true
              );

              calendarHolidayDelta.calendar = this.calendarHoliday.calendar;

              await this.updateCalendarHoliday({
                calendarId: calendarHolidayDelta.calendar,
                data: calendarHolidayDelta
              });
            } else {
              await this.createCalendarHoliday({
                calendarId: this.calendarHoliday.calendar,
                data: this.calendarHoliday
              });
            }

            this.loading = false;
            this.close();
          } catch (err) {
            this.loading = false;
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                CalendarHolidayFieldError.isCalendarHolidayFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new CalendarHolidayFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          }
        }
      }
    }
  });
